<script>
    // Licensed under Gnu Public Licence version 2
    // Copyright (c) 2023 (original work) Open Assessment Technologies SA ;
    import { createEventDispatcher } from 'svelte';
    import { IconBarButton, Heading } from '@oat-sa-private/ui-elements';

    export let startActions = [];
    export let endActions = [];
    export let heading = '';
    export let headingLevel = 2;
    export let inverted = false;

    const dispatch = createEventDispatcher();
    const iconSize = 16;

    $: maxActionItems = Math.max(startActions.length, endActions.length);

    function emitAction(key) {
        dispatch('action', { key });
    }
</script>

<style>
    .overlay-box-header {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        min-height: 5.5rem;

        & ol {
            --action-item-width: 5.5rem;
            list-style: none;
            padding: 0;
            margin: 0;
            display: flex;
            flex-wrap: nowrap;
            /* calculation makes start & end action areas equal size even if number of actions aren't,
            to make heading centered */
            flex: 1 0 calc(var(--action-items, 0) * var(--action-item-width));

            &.start li {
                border-bottom: var(--border-medium) solid var(--color-border-default);
                &:last-child {
                    border-inline-end: var(--border-medium) solid var(--color-border-default);
                }
            }

            &.end li {
                border-bottom: var(--border-medium) solid var(--color-border-default);
                &:first-child {
                    border-inline-start: var(--border-medium) solid var(--color-border-default);
                }
            }
        }

        & .heading-container {
            display: flex;
            flex: 0 1 100%;
            align-items: center;
            justify-content: center;

            & > :global(h1),
            & > :global(h2),
            & > :global(h3),
            & > :global(h4),
            & > :global(h5),
            & > :global(h6) {
                font-size: var(--fontsize-body-s);
                text-transform: uppercase;
                margin: 0;
            }
        }
    }
</style>

<div class="overlay-box-header" class:inverted style="--action-items:{maxActionItems}">
    <ol class="actions start">
        {#each startActions as buttonProps}
            <li class="inverted">
                <IconBarButton
                    {...buttonProps}
                    size={`base-${iconSize}`}
                    icon={`${buttonProps.icon}-${iconSize}`}
                    on:click={() => emitAction(buttonProps.key)} />
            </li>
        {/each}
    </ol>
    {#if heading}
        <div class="heading-container">
            <Heading level={headingLevel}>{heading}</Heading>
        </div>
    {/if}
    <ol class="actions end">
        {#each endActions as buttonProps}
            <li class="inverted">
                <IconBarButton
                    {...buttonProps}
                    size={`base-${iconSize}`}
                    icon={`${buttonProps.icon}-${iconSize}`}
                    on:click={() => emitAction(buttonProps.key)} />
            </li>
        {/each}
    </ol>
</div>
